<div class="login-inside-container" id="div_login-inside-container_975b3f31">
  <h1 aria-label="WELCOME" title="WELCOME" id="h1_e61efde4">WELCOME.</h1>
  <form [formGroup]="frmCreatePassword" id="form_1ae940d5">
    <label id="label_abf2f0c9"
      >Please create a password to register your account.</label
    >
    <span class="p-float-label" id="span_p-float-label_0d21a05c">
      <input
        id="password"
        type="password"
        [pTooltip]="toolTip"
        tooltipEvent="focus"
        [escape]="false"
        tooltipPosition="right"
        pInputText=""
        name="password"
        formControlName="password"
        aria-label="Password Input"
      />
      <label for="password" id="label_b21275b4">Password</label>
    </span>
    <small
      class="p-error block"
      *ngIf="frmCreatePassword.controls['password'].hasError('pattern')"
      aria-label="Password does not meet requirements."
      id="small_p-error_1f9f54b0"
    >
      Password does not meet requirements.
    </small>
    <span class="p-float-label" id="span_p-float-label_7fcff735">
      <input
        id="confirmPassword"
        type="password"
        [pTooltip]="toolTip"
        tooltipEvent="focus"
        [escape]="false"
        tooltipPosition="right"
        pInputText=""
        name="confirmPassword"
        formControlName="confirmPassword"
        aria-label="Confirm Password Input"
      />
      <label for="confirmPassword" id="label_0db8f6c8">Confirm Password</label>
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmCreatePassword.value.password !==
        frmCreatePassword.value.confirmPassword
      "
      aria-label="Passwords do not match."
      id="small_p-error_aff91d9c"
    >
      Passwords do not match.
    </small>
    <div class="terms-pnl" id="div_terms-pnl_dc728f6d">
      <label
        for="termsCondition"
        class="label-checkbox"
        id="label_label-checkbox_f36ad2d0"
      >
        <input
          type="checkbox"
          id="termsCondition"
          name="termsCondition"
          formControlName="termsCondition"
          aria-label="Terms and Conditions Checkbox"
        />
        <span id="span_a3c998a8"></span>
        I agree to the
        <a
          aria-label="Terms & Conditions"
          title="Terms & Conditions"
          href="https://legal.trin.net/"
          id="a_d88f5e19"
        >
          Terms & Conditions
        </a>
      </label>
    </div>
    <div class="captcha-row" id="div_captcha-row_c811903a">
      <p-captcha
        siteKey="6LcPRjciAAAAANIVIBXMAQpTlSJ8ZMF_4Ih4fIqw"
        (onExpire)="resetCaptcha()"
        (onResponse)="showResponse($event)"
        aria-label="Captcha"
        id="p-captcha_3cddacca"
      ></p-captcha>
    </div>
    <div class="btn-panel" id="div_btn-panel_96f9650c">
      <button
        class="next-button"
        (click)="confirm()"
        [disabled]="!frmCreatePassword.valid || captcha_token === ''"
        aria-label="Next Button"
        id="button_next-button_8579fdbc"
      >
        NEXT
      </button>
    </div>
  </form>
</div>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_35ad3641"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    aria-label="Loading Spinner"
    id="p-progressSpinner_9d070685"
  ></p-progressSpinner>
</div>
